import { planClassOverlap } from './classOverlapFix';

const SEVERITY_RANK = { none: 0, overlap: 1, audit: 2, national: 3 };
const BY_SUBJECT = new Set(['교과', '교과_고등']);

/**
 * 학생별 기록의 생기부 글을 영역(교과는 과목까지)별로 묶어 반 점검을 한다.
 * 학생마다 영역별 가장 최근 글 하나만 쓴다(같은 학생의 옛 글끼리 겹침으로 세지 않게).
 */
export const buildRosterOverlap = (students = []) => {
  const groups = new Map();
  students.forEach((student) => {
    const seen = new Set();
    (student.items || [])
      .filter((item) => item.kind === 'saenggibu' && String(item.content || '').trim())
      .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')))
      .forEach((item) => {
        const category = item.category || item.title || '';
        const subject = BY_SUBJECT.has(category) ? String(item.subtitle || '').trim() : '';
        const key = `${category}|${subject}`;
        if (seen.has(key)) return;
        seen.add(key);
        if (!groups.has(key)) groups.set(key, { key, category, label: subject ? `${item.title} · ${subject}` : item.title, entries: [] });
        groups.get(key).entries.push({ sid: student.sid, name: student.name, number: student.number, content: item.content });
      });
  });
  return [...groups.values()]
    .filter((group) => group.entries.length >= 2)
    .map((group) => ({ ...group, plan: planClassOverlap(group.entries.map((entry) => entry.content), { category: group.category }) }))
    .sort((a, b) => b.plan.targets.length - a.plan.targets.length || b.entries.length - a.entries.length);
};

export const summarizeRosterOverlap = (groups = []) => {
  const flagged = groups.filter((group) => group.plan.targets.length > 0);
  const level = groups.reduce((top, group) => (
    SEVERITY_RANK[group.plan.summary.severity] > SEVERITY_RANK[top] ? group.plan.summary.severity : top
  ), 'none');
  return {
    groupCount: groups.length,
    flaggedGroups: flagged.length,
    flaggedStudents: new Set(flagged.flatMap((group) => group.plan.targets.map((target) => group.entries[target.index].sid))).size,
    sameCount: groups.reduce((sum, group) => sum + group.plan.summary.sameGroups, 0),
    nearCount: groups.reduce((sum, group) => sum + group.plan.summary.nearGroups, 0),
    maxPeople: groups.reduce((top, group) => Math.max(top, group.plan.summary.maxPeople || 0), 0),
    level,
  };
};
